// Function to add an item to the cart
function addItemToCart(variantId, quantity) {
  var data = {
    id: variantId,
    quantity: quantity
  };
 
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(function(response) {
      if (response.ok) {
        // Handle success, such as showing a success message or updating the cart total
        console.log('Item added to cart successfully!');
 // Wait for 2 seconds
      setTimeout(function() {
        // Reload the cart page
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }, 1000);
        console.error('Error adding item to cart:', response.status, response.statusText);
        return response.json().then(function(errorData) {
          console.error('Error details:', errorData);
        });
      }
    })
    .catch(function(error) {
      console.error('Error adding item to cart:', error);
    });
}

// Function to delete the product from the cart
function deleteProductFromCart(productId) {
  // Create a request to delete the product
  const request = new XMLHttpRequest();
  request.open("POST", "/cart/change.js", true);
  request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
  request.onload = function() {
    if (request.status === 200) {
      // Successful deletion, reload the cart or perform any other action
      console.log("Product successfully deleted from cart");
 // Wait for 2 seconds
      setTimeout(function() {
        // Reload the cart page
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }, 1000);
    } else {
      // Failed deletion, handle the error
      console.error("Error deleting product from cart");
    }
  };

  // Prepare the data to be sent in the request
  const data = `quantity=0&id=${productId}`;

  // Send the request
  request.send(data);
}

document.addEventListener('cart:updated', function(event) {
  const offerElement = document.getElementById("offer_unfulfilled");
  const offerQuantity = offerElement.getAttribute("data-offer-quantity");
  const offerAmount = offerElement.getAttribute("data-offer-amount");
  const quantity = parseInt(offerQuantity, 10);
  const amount = parseFloat(offerAmount);
  var cart = event.detail.cart; // Get the updated content of the cart
  console.log(cart);  
  var isProductInCart = cart.items.some(function(item) {
    return item.variant_id === variantId;
  });
 
 
   
    if (isProductInCart && cart.item_count <= quantity && offerQuantity !== "0") {
    deleteProductFromCart(variantId);
       console.log("quantity delete = " + quantity )
  } else if (!isProductInCart && cart.item_count >= quantity && offerQuantity !== "0") {
    addItemToCart( variantId, 1);
       console.log("quantity add = " + quantity )
  };
  
   
   
    if (isProductInCart && cart.total_price < amount && offerAmount !== "0") {
    deleteProductFromCart(variantId);
       console.log("amount delete "   + amount + cart.total_price  )
  } else if (!isProductInCart && cart.total_price > amount && offerAmount !== "0") {
    addItemToCart( variantId, 1);
       console.log("amount add "   + amount + cart.total_price )
  };
  });
document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant.id; 
    const variant_id = variant.toString();
    console.log(variant_id)
    const productTexts = document.querySelectorAll('.toggle_variant');
    productTexts.forEach(function(productText) {
                if (productText.getAttribute('data-variant') === variant_id ) {
                    productText.style.display = 'block';
                } else {
                    productText.style.display = 'none';
                }
            });
  });